import * as React from 'react';
import {useMergeRefs} from '@floating-ui/react';

import {emptyObject} from '@packages/utilities/fp/utils';

import {Slot} from '../Slot';

import {usePopoverContext} from './usePopover';

export type PopoverTriggerProps = {
  children?: React.ReactNode;
  asChild?: boolean;
  /**
   * Disables the Popover from engaging from user interaction. It also closes the Popover if it was previously opened.
   * @TODO Causes type error with getReferenceProps below: https://webflow.atlassian.net/browse/DS-1641
   */
  //isDisabled?: boolean;
};

export const PopoverTrigger = React.forwardRef<any, any>(
  ({children, asChild = true, ...props}: PopoverTriggerProps, propRef) => {
    const {refs: popoverRefs, getReferenceProps} =
      usePopoverContext() || emptyObject;
    // @ts-expect-error - TS2339 - Property 'ref' does not exist on type 'ReactNode'.
    const {ref: childrenRef} = children;
    const ref = useMergeRefs([popoverRefs?.setReference, propRef, childrenRef]);

    const Component = asChild ? Slot : 'span';

    return (
      <Component
        ref={ref}
        role="button"
        tabIndex={0}
        {...getReferenceProps?.(props)}
      >
        {children}
      </Component>
    );
  }
);
